var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMilestoneDiamond({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.29289 2.79289C9.68342 2.40237 10.3166 2.40237 10.7071 2.79289L17.2071 9.29289C17.5976 9.68342 17.5976 10.3166 17.2071 10.7071L10.7071 17.2071C10.3166 17.5976 9.68342 17.5976 9.29289 17.2071L2.79289 10.7071C2.40237 10.3166 2.40237 9.68342 2.79289 9.29289L9.29289 2.79289Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilestoneDiamond);
export default __webpack_public_path__ + "static/media/milestone-diamond.4ddf659cde48f242710c1cdf1f4773da.svg";
export { ForwardRef as ReactComponent };